const config = {
  REACT_APP_SERVER_API: 'https://api.oneclick2.com/',
};

const env = (key) => {
  if (config.hasOwnProperty(key)) return config[key];

  if (process.env.hasOwnProperty(key)) return process.env[key];

  return null;
};

module.exports = {
  REACT_APP_SERVER_API: 'REACT_APP_SERVER_API',
  REACT_APP_PAGINATION_BUTTON_COUNT: env('REACT_APP_PAGINATION_BUTTON_COUNT'),
  SERVER_API: env('REACT_APP_SERVER_API'),
  BASE_URL: env('REACT_APP_BASE_URL'),
  env,
};